import { useMutation } from "react-query";
import { updateLeasedEquipmentModel } from "../../../../../actions/Utilities/LeasedEquipmentModel";
import { toast } from "components/toastNotification";
import { IModel } from "../types";

const useEditModel = () => {
  const { mutate } = useMutation(
    (Data: IModel) => updateLeasedEquipmentModel(Data),
    {
      onSuccess: (res) => {
        switch (true) {
          case res == "Success":
            toast.fire("Success", "Model Updated Successfully", "success");
            break;
          case res.includes("Notification insert Failed"):
            toast.fire(
              "Success ",
              `Model Updated Successfully, BUT ${res}`,
              "warning"
            );
            break;
          case res == "Operation Failed!":
            toast.fire(
              "Updating Model failed ",
              `Server Error: ${res}`,
              "error"
            );
            break;
          case res == "The data already exists!":
            toast.fire(
              "Updating Model failed ",
              `Duplication Error: ${res}`,
              "error"
            );
            break;
          case res.includes("Action object"):
            toast.fire("Updating Model failed ", `Error: ${res}`, "error");
            break;
          default:
            toast.fire("Updating Model failed", `${res.Message}`, "error");
        }
      },
      onError: (error: any) => {
        toast.fire("Update Model failed", `Error: ${error}`, "error");
      },
    }
  );
  return mutate;
};

export default useEditModel;
